import { Trans } from "react-i18next";

function EmptyMessage(props) {
  return (
    <>
      <p style={{ textAlign: "left", color: "red" }}>
        <Trans>emptyMessage</Trans>
        {props.withAddition && <Trans>addInstruction</Trans>}
      </p>
    </>
  );
}

export default EmptyMessage;